import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { EditJobPosting, type EditableJob } from '../../components/employer/EditJobPosting';

export function JobCreate() {
  const navigate = useNavigate();

  const draftJob = useMemo<EditableJob>(() => ({
    id: Date.now(),
    title: '',
    location: '',
    salary: '',
    type: 'full-time',
    posted: 'Draft',
    applicants: 0,
    views: 0,
    status: 'Draft',
    description: '',
    requirements: [],
    benefits: [],
    returnerFriendly: false,
    skillTestId: undefined,
  }), []);

  return (
    <main className="min-h-screen bg-[#070917] pb-24" aria-labelledby="job-create-title">
      <header className="border-b border-white/10 bg-[#0d1022]/80 backdrop-blur-sm">
        <div className="mx-auto flex max-w-5xl flex-col gap-4 px-4 py-8 sm:px-6 lg:px-8">
          <div className="flex flex-wrap items-center justify-between gap-4">
            <div className="space-y-2">
              <p className="text-xs uppercase tracking-[0.35em] text-gray-500">Create new role</p>
              <h1 id="job-create-title" className="text-3xl font-semibold text-white sm:text-4xl">Post a new job</h1>
              <p className="text-sm text-gray-400">Craft a compelling listing before submitting for moderation.</p>
            </div>
            <div className="flex flex-col items-end gap-2 text-sm text-gray-300">
              <span>Your organisation</span>
              <Badge className="w-fit bg-white/10 text-gray-200">Draft mode</Badge>
            </div>
          </div>
          <div className="flex flex-wrap gap-3">
            <Button
              variant="outline"
              className="w-fit border-white/20 text-white hover:bg-white/10"
              onClick={() => navigate('/employer/jobs')}
            >
              Back to jobs
            </Button>
            <Button
              className="w-fit bg-gold-gradient text-black hover:brightness-110"
              onClick={() => navigate('/employer/job/wizard')}
            >
              Open AI job spec builder
            </Button>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-5xl px-4 py-10 sm:px-6 lg:px-8">
        <Card className="border-white/10 bg-white/[0.03]">
          <CardHeader>
            <CardTitle className="text-lg text-white">Job details</CardTitle>
          </CardHeader>
          <CardContent className="space-y-8">
            <EditJobPosting
              job={draftJob}
              allowDelete={false}
              primaryActionLabel="Create Job"
              successMessage="Job draft created. Submit for moderation when you're ready."
              heading="Create Job Posting"
              subheading="Define the essentials before inviting candidates"
              onClose={() => navigate('/employer/jobs')}
              onSave={() => {
                navigate('/employer/jobs', { state: { fromCreate: true } });
              }}
            />
          </CardContent>
        </Card>
      </main>
    </main>
  );
}
